export const GLOSSARY = [
  {
    "key": 1,
    "value": "@terminal",
    "description": "Refers to your terminal for your prompts."
  },
  {
    "key": 2,
    "value": "@vscode",
    "description": "Allows you to ask questions about VS Code, such as its features and settings."
  },
  {
    "key": 3,
    "value": "@workspace",
    "description": "Refers to your project’s code workspace."
  },
  {
    "key": 4,
    "value": "/clear",
    "description": "Creates a new chat session."
  },
  {
    "key": 5,
    "value": "/explain",
    "description": "Based on the curser in your IDE or the code selected, GitHub Copilot will provide an explanation, which often includes a code sample."
  },
  {
    "key": 6,
    "value": "/fix",
    "description": "Provides fixes for issues with your code."
  },
  {
    "key": 7,
    "value": "/fixTestFailure",
    "description": "Provides suggestions for a fix when a unit test fails."
  },
  {
    "key": 8,
    "value": "/new",
    "description": "Sets up the files for the scaffolding of a new project."
  },
  {
    "key": 9,
    "value": "/newNotebook",
    "description": "Creates a new Jupyter notebook. This can be used for data science projects in your IDE."
  },
  {
    "key": 10,
    "value": "/search",
    "description": "Suggests query parameters for workspace search in VS Code."
  },
  {
    "key": 11,
    "value": "/setupTests",
    "description": "Creates the files to set up Playwright in your project."
  },
  {
    "key": 12,
    "value": "/startDebugging",
    "description": "Generates a launch configuration, which you can use for debugging in VS Code."
  },
  {
    "key": 13,
    "value": "/test",
    "description": "Generates unit tests."
  },
  {
    "key": 14,
    "value": "#editor",
    "description": "The context for the code in the active file in the IDE’s editor."
  },
  {
    "key": 15,
    "value": "#file",
    "description": "Refers to a file in your prompt for GitHub Copilot Chat."
  },
  {
    "key": 16,
    "value": "#selection",
    "description": "Provides the context for the code that’s selected in the editor."
  },
  {
    "key": 17,
    "value": "#terminalLastCommand",
    "description": "The context of the terminal’s last command that has been executed."
  },
  {
    "key": 18,
    "value": "#terminalSelection",
    "description": "The context of the active terminal’s selection."
  },
  {
    "key": 19,
    "value": "01-preview",
    "description": "A large language model from OpenAI. It’s available in GitHub Copilot. See large language model."
  },
  {
    "key": 20,
    "value": "01-mini",
    "description": "A large language model from OpenAI. It’s available in GitHub Copilot. See large language model."
  },
  {
    "key": 21,
    "value": "abstraction",
    "description": "Simplifying complex systems, which is critical for software development."
  },
  {
    "key": 22,
    "value": "activation function",
    "description": "Used to process data in a deep learning model. The activation function will essentially ignore negative values."
  },
  {
    "key": 23,
    "value": "agentic AI",
    "description": "An AI system that uses multiple LLMs to engage in planning, reasoning, and tools to solve complex, multi-step problems. See large language model."
  },
  {
    "key": 24,
    "value": "agile model",
    "description": "An approach to software development that focuses on speed, flexibility, and incremental development."
  },
  {
    "key": 25,
    "value": "AI coding",
    "description": "A tool that uses AI for writing, testing, and debugging code."
  },
  {
    "key": 26,
    "value": "air gapped environment",
    "description": "When a computer or network is physically isolated from unsecured networks like the public Internet."
  },
  {
    "key": 27,
    "value": "array",
    "description": "A data structure that stores a fixed-size sequence of elements of the same type in memory."
  },
  {
    "key": 28,
    "value": "artificial intelligence (AI)",
    "description": "A field that allows machines to engage in learning, reasoning, problem solving, and decision-making."
  },
  {
    "key": 29,
    "value": "assertion method",
    "description": "In unit testing, this verifies whether a condition is true or false."
  },
  {
    "key": 30,
    "value": "attention mechanisms",
    "description": "A key feature of the transformer model that processes text as a whole."
  },
  {
    "key": 31,
    "value": "audit logs",
    "description": "Chronological records that track activities and tasks for security and compliance purposes in GitHub Copilot."
  },
  {
    "key": 32,
    "value": "backpropagation",
    "description": "The process where a deep learning model works backward so as to help improve the results."
  },
  {
    "key": 33,
    "value": "bias",
    "description": "Unfair responses or predictions from an AI system."
  },
  {
    "key": 34,
    "value": "big bang model",
    "description": "An approach to software development that is less structured and involves little planning. It is usually for small projects."
  },
  {
    "key": 35,
    "value": "black box",
    "description": "An AI system that is not transparent."
  },
  {
    "key": 36,
    "value": "chain-of-thought (CoT) prompting",
    "description": "Creating a prompt that helps improve the problem-solving capabilities of a large language model. It’s about breaking complex problems into logical and easier steps."
  },
  {
    "key": 37,
    "value": "contextual information",
    "description": "Information, such as a file, that is provided in a prompt for an AI model."
  },
  {
    "key": 38,
    "value": "context window",
    "description": "The number of tokens an LLM can process. See token."
  },
  {
    "key": 39,
    "value": "Claude 3.5 Sonnet",
    "description": "A large language model from Anthropic. It’s available in GitHub Copilot. See large language model."
  },
  {
    "key": 40,
    "value": "code completion",
    "description": "An LLM generates code based on what you have already entered in an IDE."
  },
  {
    "key": 41,
    "value": "code refactoring",
    "description": "Describes the process of optimizing existing code."
  },
  {
    "key": 42,
    "value": "code smells",
    "description": "Poorly designed code."
  },
  {
    "key": 43,
    "value": "code translation",
    "description": "Converting the codebase from one programming language to another."
  },
  {
    "key": 44,
    "value": "concurrency errors",
    "description": "Errors that occur during the concurrent execution of a program, such as with deadlocks."
  },
  {
    "key": 45,
    "value": "conditional",
    "description": "This makes a decision in a program, such as with an structure."
  },
  {
    "key": 46,
    "value": "context",
    "description": "The initial information or setting provided within a prompt, which helps guide the LLM’s response."
  },
  {
    "key": 47,
    "value": "continuous integration/continuous deployment (CI/CD)",
    "description": "A set of practices and tools for enabling automation scripts for faster and more reliable software releases."
  },
  {
    "key": 48,
    "value": "coverage tool",
    "description": "Helps to detect untested parts of your code."
  },
  {
    "key": 49,
    "value": "cross-site script (XSS)",
    "description": "The insertion of malicious scripts into a web page via security vulnerability."
  },
  {
    "key": 50,
    "value": "custom model",
    "description": "A fine-tuned version of the LLM from GitHub Copilot. This allows for more customization of the code generation."
  },
  {
    "key": 51,
    "value": "database schema",
    "description": "Defines how data is organized in a database."
  },
  {
    "key": 52,
    "value": "data preprocessing",
    "description": "Improving the quality of a dataset before using it for training an AI model."
  },
  {
    "key": 53,
    "value": "dead code",
    "description": "Functions, variables, or code blocks that no longer function in an application."
  },
  {
    "key": 54,
    "value": "decision trees",
    "description": "An AI model that uses a tree-like structure of decisions and outcomes to classify data or make predictions."
  },
  {
    "key": 55,
    "value": "decomposing conditionals",
    "description": "Breaking down complex structures into more focused conditions."
  },
  {
    "key": 56,
    "value": "deep learning",
    "description": "A form of AI that uses large amounts of data and complex algorithms, which mimic the human brain. This involves sophisticated connections between nodes or neurons that help the system to learn."
  },
  {
    "key": 57,
    "value": "devops",
    "description": "Combines software development and operations teams, which helps to improve collaboration."
  },
  {
    "key": 58,
    "value": "docstring",
    "description": "The first statement in a Python function to describe it."
  },
  {
    "key": 59,
    "value": "domain requirements",
    "description": "About a particular category, such as finance, legal, marketing and so on."
  },
  {
    "key": 60,
    "value": "embeddings",
    "description": "A way to represent data—such as words or images—as numerical vectors, so that similar items are close together in meaning or structure."
  },
  {
    "key": 61,
    "value": "encryption",
    "description": "Method for making data only readable by using a private key, which is a long list of numbers (it’s like a password)."
  },
  {
    "key": 62,
    "value": "ensemble programming",
    "description": "Combing multiple models to improve overall performance, accuracy, and robustness."
  },
  {
    "key": 63,
    "value": "exception handling",
    "description": "Where your code will manage errors or unexpected outcomes."
  },
  {
    "key": 64,
    "value": "explainable AI (XAI)",
    "description": "Guidelines and tools to help make AI models more understandable."
  },
  {
    "key": 65,
    "value": "explicit bias",
    "description": "Conscious attitudes or beliefs that individuals hold about certain groups, which can influence decisions and behaviors in a deliberate way."
  },
  {
    "key": 66,
    "value": "extract method",
    "description": "A code refactoring technique that rearranges the function or method into one or more of them."
  },
  {
    "key": 67,
    "value": "fairness",
    "description": "In an AI system, this is about treating people in a similar way."
  },
  {
    "key": 68,
    "value": "feature",
    "description": "A variable used in an AI model. It represents a category of data."
  },
  {
    "key": 69,
    "value": "few-shot learning",
    "description": "Where a prompt includes some examples. This helps provide context for the large language model. See large language model."
  },
  {
    "key": 70,
    "value": "fine-tuning",
    "description": "Customization of a large language model by embedding proprietary data. See large language model."
  },
  {
    "key": 71,
    "value": "firmware",
    "description": "A specialized form of software that is integrated in devices."
  },
  {
    "key": 72,
    "value": "forward propagation",
    "description": "The process for feeding data into a deep learning model."
  },
  {
    "key": 73,
    "value": "full-stack development",
    "description": "Creating code for both the UI and on the server-side or backend of the application."
  },
  {
    "key": 74,
    "value": "function",
    "description": "A block of code that performs a task."
  },
  {
    "key": 75,
    "value": "functional requirements",
    "description": "Defining specific functions or capabilities of a system, say the underlying calculations, data processing, and user experience."
  },
  {
    "key": 76,
    "value": "Gemini 1.5 Pro",
    "description": "A large language model from Google. It’s available in GitHub Copilot. See large language model."
  },
  {
    "key": 77,
    "value": "generative AI (GenAI)",
    "description": "Allows for creating and understanding content, whether text, voice, images, or video. This is at the heart of AI coding systems."
  },
  {
    "key": 78,
    "value": "Git",
    "description": "An open-source version control system used to track changes in source code and coordinate work among multiple developers."
  },
  {
    "key": 79,
    "value": "GitHub Copilot",
    "description": "Development tool that uses generative AI models to create, test, and debug code."
  },
  {
    "key": 80,
    "value": "GitHub Copilot Chat",
    "description": "An AI-powered chatbot for software development. It is integrated with your code."
  },
  {
    "key": 81,
    "value": "graphics processing units (GPUs)",
    "description": "Chips that can process huge amounts of data in parallel. They are often used for GenAI systems."
  },
  {
    "key": 82,
    "value": "hallucination",
    "description": "False or misleading content created by a generative AI system."
  },
  {
    "key": 83,
    "value": "hash table",
    "description": "Stores key-value pairs for looking up, inserting, and deleting data."
  },
  {
    "key": 84,
    "value": "implicit bias",
    "description": "Unconscious attitudes or stereotypes that influence our understanding, actions, and decisions without intentional awareness."
  },
  {
    "key": 85,
    "value": "inference",
    "description": "A processing of the input from a user of an AI system."
  },
  {
    "key": 86,
    "value": "inline chat",
    "description": "Allows you to use GitHub Copilot Chat in your IDE."
  },
  {
    "key": 87,
    "value": "Integrated Development Environment (IDE)",
    "description": "Software application that provides comprehensive tools—such as a code editor, debugger, and compiler—to help developers write, test, and debug code."
  },
  {
    "key": 88,
    "value": "integration testing",
    "description": "Testing all components of a codebase."
  },
  {
    "key": 89,
    "value": "knowledge base",
    "description": "A collection of documentation files—in markdown format—that are in one or more repositories for an organization. You use this to provide more context when using Copilot Chat, such as on an IDE or GitHub.com."
  },
  {
    "key": 90,
    "value": "kubernetes",
    "description": "Packages applications into containers."
  },
  {
    "key": 91,
    "value": "labeling data",
    "description": "The process to assign descriptions to data. This helps train AI models."
  },
  {
    "key": 92,
    "value": "large language model (LLM)",
    "description": "A generative AI system that relies on the transformer model. A large language model is trained on enormous amounts of data. See transformer model."
  },
  {
    "key": 93,
    "value": "lean development",
    "description": "A software development approach that attempts to maximize value and minimize waste."
  },
  {
    "key": 94,
    "value": "linear regression",
    "description": "A statistical method that models the relationship between a dependent variable and one or more independent variables by fitting a straight line to the observed data."
  },
  {
    "key": 95,
    "value": "logic errors",
    "description": "Mistakes in a program’s reasoning that cause it to produce incorrect results, even though it runs without crashing."
  },
  {
    "key": 96,
    "value": "loop",
    "description": "This iterates a block of code. This can be for a specific number of times (a loop) or when a condition is hit (a loop)."
  },
  {
    "key": 97,
    "value": "machine learning",
    "description": "A subset of AI that allows for machines to learn without being explicitly programmed."
  },
  {
    "key": 98,
    "value": "memory errors",
    "description": "Describes problems with memory allocation and deallocation, such as memory leaks or buffer overflows."
  },
  {
    "key": 99,
    "value": "mob programming",
    "description": "A software development approach where the entire team works together on the same code, at the same time, on the same computer."
  },
  {
    "key": 100,
    "value": "model poisoning",
    "description": "A manipulation of a dataset or parameters of an AI model."
  },
  {
    "key": 101,
    "value": "multi-head self-attention",
    "description": "A process in the transformer model that shows which tokens to focus on. See transformer model."
  },
  {
    "key": 102,
    "value": "multimodal",
    "description": "A large language model that integrates different forms of content creation, such as text, sound, images, and video. See large language models."
  },
  {
    "key": 103,
    "value": "multi-model",
    "description": "An AI application that allows you to select different large language models. See large language models."
  },
  {
    "key": 104,
    "value": "Naïve Bayes Classifier",
    "description": "A probabilistic machine learning algorithm based on Bayes’ Theorem that assumes independence between features to classify data."
  },
  {
    "key": 105,
    "value": "ninja code",
    "description": "Code that is highly cryptic and complex."
  },
  {
    "key": 106,
    "value": "non-functional requirements",
    "description": "Focused on identifying the criteria to judge the operation of a system. This is usually about performance, reliability, and security."
  },
  {
    "key": 107,
    "value": "object-oriented programming",
    "description": "A programming approach based on the concept of “objects” that contain data and methods that operate on that data."
  },
  {
    "key": 108,
    "value": "organization",
    "description": "A shared account—in GitHub—where you can collaborate on many projects. The organization will also benefit from strong security and administrative features."
  },
  {
    "key": 109,
    "value": "pair programming",
    "description": "A collaborative approach to software development. Usually, one programmer will do the coding and another will assist."
  },
  {
    "key": 110,
    "value": "parameters",
    "description": "Weights and biases (constants) used for the training of an AI model."
  },
  {
    "key": 111,
    "value": "personally identifiable information (PII)",
    "description": "Data that can identify a person, such as an address, social security number, email, or phone number. Generally, this is information that should be secured."
  },
  {
    "key": 112,
    "value": "positional encoding",
    "description": "The process to put words in the right order so an AI model can generate effective results."
  },
  {
    "key": 113,
    "value": "prompt engineering",
    "description": "Approaches for writing effective prompts for large language models. See large language models."
  },
  {
    "key": 114,
    "value": "prompt files",
    "description": "Files that allow you to reuse prompt instructions in GitHub Copilot."
  },
  {
    "key": 115,
    "value": "prompt libraries",
    "description": "Curated collections of prompts."
  },
  {
    "key": 116,
    "value": "proxy filter",
    "description": "A server that is an intermediary between a user’s device and the Internet. This provides for monitoring, filtering, and modifying data to block unwanted content or protect sensitive information."
  },
  {
    "key": 117,
    "value": "pull request",
    "description": "A way for developer to propose and collaborate on changes within a codebase. This is done by using a version control system like GitHub or git."
  },
  {
    "key": 118,
    "value": "quality assurance (QA)",
    "description": "Ensures that the software meets requirements and quality standards."
  },
  {
    "key": 119,
    "value": "regular expression (Regex)",
    "description": "A sequence of characters that represents a pattern. Used in scenarios like validating email formats, searching for specific phrases, or extracting information."
  },
  {
    "key": 120,
    "value": "reinforcement learning",
    "description": "An AI model that learns to make decisions by interacting with an environment to maximize cumulative rewards."
  },
  {
    "key": 121,
    "value": "reinforcement learning from human feedback (RLHF)",
    "description": "Involves having people evaluate the responses of the LLM."
  },
  {
    "key": 122,
    "value": "remote pair programming",
    "description": "A collaborative software development approach where two developers work together on the same codebase from different locations, typically using screen sharing or specialized tools."
  },
  {
    "key": 123,
    "value": "requirements analysis",
    "description": "Collecting, documenting, and managing the needs from stakeholders about a software project."
  },
  {
    "key": 124,
    "value": "responsible AI",
    "description": "Designing, developing, deploying, and monitoring AI systems in a way that accounts for the technology’s impact on society, the law, and ethical standards."
  },
  {
    "key": 125,
    "value": "retrieval augmented generation (RAG)",
    "description": "The customization of a large language model by connecting a proprietary dataset. This is done by using a sophisticated search algorithm. See large language models."
  },
  {
    "key": 126,
    "value": "runtime error",
    "description": "An error that happens during the code execution. Examples include bad null pointer references or division by zero."
  },
  {
    "key": 127,
    "value": "sigmoid function",
    "description": "A mathematical function that maps a result of a model between 0 and 1. This is used where there are binary decisions, such as “yes” or “no.”"
  },
  {
    "key": 128,
    "value": "small language model (SLM)",
    "description": "An AI model that is a fraction of the size of an LLM. However, they may still be powerful. They are also faster, making it easier to handle real-time processing. See large language models."
  },
  {
    "key": 129,
    "value": "software development life cycle (SDLC)",
    "description": "Describes the main phases in developing applications."
  },
  {
    "key": 130,
    "value": "software testing",
    "description": "Verifying whether an application does what it is intended to do."
  },
  {
    "key": 131,
    "value": "SQL injection",
    "description": "Manipulation of SQL queries to insert malicious code, which can lead to accessing sensitive information."
  },
  {
    "key": 132,
    "value": "structured query language (SQL)",
    "description": "Scripting language for managing relational databases, such as to create, modify, and query data."
  },
  {
    "key": 133,
    "value": "subroutine",
    "description": "Reusable code that performs specific tasks and can be called multiple times from different parts of the program."
  },
  {
    "key": 134,
    "value": "supervised learning",
    "description": "How an AI model learns by applying algorithms to labeled data. This is often to classify or categorize the data."
  },
  {
    "key": 135,
    "value": "syntax error",
    "description": "Describes an error with the grammar of a programming language, such as unmatched parentheses or incorrect indention."
  },
  {
    "key": 136,
    "value": "technical debt",
    "description": "Software that is the result of a focus on speed, not maintainable code. This can mean that the codebase becomes bloated and difficult to change."
  },
  {
    "key": 137,
    "value": "telemetry data",
    "description": "Information about the performance of a system."
  },
  {
    "key": 138,
    "value": "test-driven development (TDD)",
    "description": "Where you begin testing before writing the code."
  },
  {
    "key": 139,
    "value": "token",
    "description": "A number that represents a word, part of a word, character, or punctuation. Tokens are used to train AI models."
  },
  {
    "key": 140,
    "value": "tokenization",
    "description": "The process of splitting a sentences into tokens or numbers. This allows a computer to understand the information. See token."
  },
  {
    "key": 141,
    "value": "training",
    "description": "Processing a dataset with AI algorithms to help it learn patterns. This is the key part of creating an AI model."
  },
  {
    "key": 142,
    "value": "transformer model",
    "description": "An AI model that is the basis of generative AI."
  },
  {
    "key": 143,
    "value": "unit testing",
    "description": "Involves testing a small functional unit of the codebase."
  },
  {
    "key": 144,
    "value": "unsupervised learning",
    "description": "An AI model learns from using unlabeled data. The focus is generally on groups and clusters."
  },
  {
    "key": 145,
    "value": "variable",
    "description": "A stored value in a program that can be changed during execution."
  },
  {
    "key": 146,
    "value": "vectors",
    "description": "Strings of numbers. These are used to represent data for the training of AI models."
  },
  {
    "key": 147,
    "value": "waterfall model",
    "description": "Traditional approach to software development, which tends to have detailed instructions, and each phase must be completed before going to the next one."
  },
  {
    "key": 148,
    "value": "zero-shot learning",
    "description": "A prompt that does not include any training examples."
  },
  {
    "key": 149,
    "value": "zettabyte (ZB)",
    "description": "One trillion gigabytes or one sextillion bytes."
  }
];
